/* tslint:disable */

declare var Object: any;
export interface Codigo_postalInterface {
  "id"?: number;
  "colonia": string;
  "estado": string;
  "cp": string;
}

export class Codigo_postal implements Codigo_postalInterface {
  "id": number;
  "colonia": string;
  "estado": string;
  "cp": string;
  constructor(data?: Codigo_postalInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Codigo_postal`.
   */
  public static getModelName() {
    return "Codigo_postal";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Codigo_postal for dynamic purposes.
  **/
  public static factory(data: Codigo_postalInterface): Codigo_postal{
    return new Codigo_postal(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Codigo_postal',
      plural: 'Codigo_postals',
      path: 'Codigo_postals',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
        "colonia": {
          name: 'colonia',
          type: 'string'
        },
        "estado": {
          name: 'estado',
          type: 'string'
        },
        "cp": {
          name: 'cp',
          type: 'string'
        },
      },
      relations: {
      }
    }
  }
}
